import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-popover-tooltip',
  templateUrl: './popover-tooltip.component.html',
  styleUrls: ['./popover-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PopoverTooltipComponent {
  @Input() public popoverText: string;
}
